export const clearExpiredPaymentContexts = () => {
  const EXPIRY_MS = 24 * 60 * 60 * 1000
  const now = Date.now()

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (key && key.startsWith('paymentContext_')) {
      try {
        const dataStr = localStorage.getItem(key)
        if (dataStr) {
          const data = JSON.parse(dataStr)
          if (data.createdAt && now - data.createdAt > EXPIRY_MS) {
            localStorage.removeItem(key)
          }
        }
      } catch (e) {
        localStorage.removeItem(key)
      }
    }
  }
}

export const getPaymentContext = (orderId) => {
  try {
    const dataStr = localStorage.getItem(`paymentContext_${orderId}`)
    if (dataStr) {
      return JSON.parse(dataStr)
    }
  } catch (e) {
    console.error('获取 paymentContext 失败', e)
  }
  return null
}

export const removePaymentContext = (orderId) => {
  localStorage.removeItem(`paymentContext_${orderId}`)
}

export const savePaymentContext = (orderId, context) => {
  localStorage.setItem(`paymentContext_${orderId}`, JSON.stringify({
    ...context,
    createdAt: Date.now(),
    version: '1.0'
  }))
}
